export default "__VITE_ASSET__CpxYiFQD__"